import { useState, useCallback } from 'react';
import { PoliciesAPI } from '@services/api';
import { USER_SESSION } from '@plataforma/utils';
import useCookie from './useCookie';

export default function useModalBrokerUsers() {
  const [userCookie, setUserCookie] = useCookie(USER_SESSION);
  const [selectedUser, setUser] = useState(undefined);

  const [modal, setModal] = useState({
    list: [],
    isFetching: false,
    menu: [],
    selectedUser: null
  });

  const fetchBrokerUsers = useCallback(async () => {
    setModal(prevState => ({
      ...prevState,
      isFetching: true
    }));

    try {
      const usersList = await PoliciesAPI.getEmployees();

      await setModal(prevState => ({
        ...prevState,
        isFetching: false,
        list: usersList.length
          ? [{ id: 0, name: 'Nenhum usuário', userId: 0 }, ...usersList]
          : []
      }));

      return usersList.length > 0;
    } catch (error) {
      setModal(prevState => ({
        ...prevState,
        isFetching: false
      }));

      return false;
    }
  }, []);

  const identifyUser = async () => {
    const hasUsersLocal = await fetchBrokerUsers();
    return hasUsersLocal && !userCookie;
  };

  const handleOnConfirmUser = () => {
    if (modal.selectedUser !== null && modal.selectedUser.id !== 0) {
      setUserCookie(
        JSON.stringify({
          name: modal.selectedUser.name,
          id: modal.selectedUser.id
        })
      );
      setUser(modal.selectedUser);
    } else {
      setUserCookie(JSON.stringify({ name: 'default', id: 0 }));
    }
  };

  const handleOnChangeUserSelect = user => {
    setModal(prevState => ({
      ...prevState,
      selectedUser: user
    }));
  };

  const userChangeMenu = modal.list
    ? [
        {
          title: 'Alterar usuário',
          onClick: () => {},
          userType: 'ADMINISTRAR_TOMADORES'
        }
      ]
    : [];

  return {
    brokerUsersModalState: modal,
    handleOnConfirmUser,
    handleOnChangeUserSelect,
    userChangeMenu,
    selectedUser,
    identifyUser
  };
}
